var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isEmpty } from 'lodash-es';
function mergeLogOption(source1, source2) {
    const { action: action1 = [], meta: meta1 } = source1, rest1 = __rest(source1, ["action", "meta"]);
    const { action: action2 = [], meta: meta2 } = source2, rest2 = __rest(source2, ["action", "meta"]);
    const meta = Object.assign(Object.assign({}, meta1), meta2);
    return Object.assign(Object.assign(Object.assign(Object.assign({}, rest1), rest2), { action: [...action1, ...action2] }), (isEmpty(meta) ? {} : { meta }));
}
export class LogOptionsHelper {
    static merge(...list) {
        return list
            .filter(Boolean)
            .reduce((r, c) => mergeLogOption(r, c), {});
    }
    constructor(options) {
        this.options = options;
    }
    updateMeta(updateCb) {
        this.options.meta = updateCb(this.options.meta);
    }
    get() {
        return this.options;
    }
}
